import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=3084b3f6&"
import script from "./Users.vue?vue&type=script&lang=jsx&"
export * from "./Users.vue?vue&type=script&lang=jsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports